import React, { Component } from "react";
import { Route, HashRouter, Switch } from "react-router-dom";

import Home from "./components/home/Home.js";
import ControlPanel from "./components/controlPanel/ControlPanel";
import Admin from "./components/tenantAdmin/Admin.js";

import Login from "./components/auth/Login.js";
import LoginSmall from "./components/auth/LoginSmall.js";
import LoginBig from "./components/auth/LoginBig.js";
import LoginMobile from "./components/auth/LoginMobile.js";
import RegisterBig from "./components/auth/RegisterBig";
import RegisterSmall from "./components/auth/RegisterSmall";
import LoginHelpMobile from "./components/auth/LoginHelpMobile";
import CurrentUserSmall from "./components/top/CurrentUserSmall";
import AlertEntrySmall from "./components/home/AlertEntrySmall";
import CurrentUserChangePasswordSmall from "./components/top/CurrentUserChangePasswordSmall";
import ForgotUsernameBig from "./components/auth/ForgotUsernameBig";
import ForgotUsernameSmall from "./components/auth/ForgotUsernameSmall";
import ForgotPasswordBig from "./components/auth/ForgotPasswordBig";
import ForgotPasswordSmall from "./components/auth/ForgotPasswordSmall";
import PasswordReset from "./components/auth/PasswordReset";
import CompleteRegistration from "./components/auth/CompleteRegistration";
import ConfirmAlertEmail from "./components/auth/ConfirmAlertEmail.js";
import {PrivateRoute} from "./components/auth/PrivateRoute.js";


export default class App extends Component {

  render() {
      return (
        <HashRouter>
          <div className="App">
          <div style={{maxWidth:2000, margin:'0 auto'}} className="content">
          <Switch>
            <Route exact path="/" component={Login} />
            <Route path="/loginMobile" component={LoginMobile} />
            <Route path="/login" component={Login} />
            <Route path="/home" component={Home} />
            <Route path="/currentUserChangePasswordMobile" component={CurrentUserChangePasswordSmall} />
            <Route path="/currentUserMobile" component={CurrentUserSmall} />
            <Route path="/alertEntryMobile" component={AlertEntrySmall} />
            <Route path="/registerMobile" component={RegisterSmall} />
            <Route path="/loginHelpMobile" component={LoginHelpMobile} />
            <Route path="/register" component={RegisterBig} />
            <Route path="/passwordReset/:ticket" component={PasswordReset} />
            <Route path="/CompleteRegistration/:ticket" component={CompleteRegistration} />
            <Route path="/ConfirmEmail/:ticket" component={ConfirmAlertEmail} />
            <Route path="/forgotUsernameMobile" component={ForgotUsernameSmall} />
            <Route path="/forgotUsername" component={ForgotUsernameBig} />
            <Route path="/forgotPasswordMobile" component={ForgotPasswordSmall} />
            <Route path="/forgotPassword" component={ForgotPasswordBig} />
            <PrivateRoute path="/tenantAdmin" component={Admin} />
            <PrivateRoute path="/controlPanel" component={ControlPanel} />
          </Switch>
          </div>
        </div>
      </HashRouter >

    );
  }
}